import React, { useMemo } from "react";
import { toggleLinksSidebar, toggleSidebar } from "../../store/actions";
import { useDispatch } from "react-redux";
import useWindowSize from "../../hooks/useWindowSize";

const MenuButtons = ({ color, hoverColor }) => {
  const dispatch = useDispatch();
  const [width] = useWindowSize();

  const isVisible = useMemo(() => {
    return width < 1024;
  }, [width]);

  return (
    <ul className={`text-${color} list-none pl-30 flex m-0 pr-7 items-center`}>
      {isVisible && (
        <li className="pl-14 pb-5">
          <button
            onClick={() => dispatch(toggleSidebar())}
            className={`text-${color} block hover:text-${
              hoverColor || "white"
            } hover:opacity-60`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </li>
      )}
      <li className="pl-14 pb-5">
        <button
          onClick={() => dispatch(toggleLinksSidebar())}
          className={`text-${color} block hover:text-${
            hoverColor || "white"
          } hover:opacity-60`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </li>
    </ul>
  );
};

export default MenuButtons;
